import type { TemplateFunction, TemplateFunctionInvoker, TemplateResult } from 'Components/types';

import VehicleWidget from '../../vehicleWidget/index';
import type { VehicleWidgetTemplateParams } from '../../vehicleWidget/vehicleWidget';
import { vehicleWidgetName } from '../garage';

interface Props {
  template: TemplateFunction<VehicleDropdownsTemplateParams>;
  closeGarage: () => void;
  doNotRedirectOnVehicleSelect?: boolean;
  isAutoVehicleSelectionDisabled: boolean;
  redirectUrl?: string;
  useNativeDropdown?: boolean;
}

export interface VehicleDropdownsTemplateParams {
  closeGarage: () => void;
  vehicleWidget: TemplateFunctionInvoker<VehicleWidgetTemplateParams>;
  template: 'vehicleDropdowns';
}

export default function VehicleDropdowns({
  template,
  closeGarage,
  doNotRedirectOnVehicleSelect,
  isAutoVehicleSelectionDisabled,
  redirectUrl,
  useNativeDropdown,
}: Props): TemplateResult {
  const vehicleWidget = (templ: TemplateFunction<VehicleWidgetTemplateParams>) => {
    const props = {
      isAlwaysActive: true,
      isAlwaysColumnLayout: true,
      isAutoVehicleSelectionDisabled,
      name: vehicleWidgetName,
      onSelectVehicle: closeGarage,
      doNotRedirectOnVehicleSelect,
      redirectUrl,
      useNativeDropdown,
      template: templ,
    };
    return <VehicleWidget {...props} key={vehicleWidgetName} />;
  };

  return template.call({ closeGarage, vehicleWidget, template: 'vehicleDropdowns' });
}
